import { gql } from '@apollo/client';

export const RESET_SESSION_TIMEOUT = gql`
  mutation resetSessionTimeout($input: ResetSessionTimeoutInput!) {
    resetSessionTimeout(input: $input) {
     clientMutationId
     errors
    }
  }
`

//Example input:
// {
//   "input": {
//     "addressId": 1,
//     "officerId": 1,
//     "alertTypeId": 1,
//     "notes": 1,
//     "expireAt": 1,
//     "clientMutationId": 1
//   }
// }